export default __webpack_public_path__ + "static/nmcintosh-e99f8518bba64923d405a0766fd7e5c8.jpg";